module.exports = __webpack_public_path__ + "static/bg-nature-3-39581590b583b5835fdcd62241fec946.jpg";